import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { ActivatedRoute, Router } from '@angular/router';
import {
  choice_array,
  choices,
  formViewIF,
  QuizResultIF,
  QuizResultQuestionIF,
  sendForm,
  setForm,
  typeForm,
  valueForm,
} from './preview-forms.interface';
import { AlertService } from 'src/app/service/alert.service';
import { AppURL, getUploadsBaseURL } from 'src/app/app.url';
import { AuthService } from 'src/app/service/auth.service';
import { AccountURL } from 'src/app/module/account/account.url';
import { resolveMediaUrl } from 'src/app/shareds/utils/media-url.util';
import { environment } from 'src/environments/environment';
import { FormatDateService } from 'src/app/service/format-date.service';
import { AbResolveService } from 'src/app/service/ab-resolve.service';
import { KeysConfig } from 'src/app/configs/keys.config';
import { stripHtml } from 'src/app/shareds/utils/strip-html.util';

@Component({
    selector: 'app-preview-forms',
    templateUrl: './preview-forms.component.html',
    styleUrls: ['./preview-forms.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PreviewFormsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  /** ตัด tag HTML ออกเหลือแต่ข้อความล้วน — ใช้กับข้อความยืนยัน/ขอบคุณที่ฝัง form_name ไว้กลางประโยค (ไม่ใช่จุดแสดงเนื้อหาแบบมีสไตล์) */
  stripHtml(html: string | null | undefined): string {
    return stripHtml(html);
  }
  form_id: any;
  key_id: any;
  modelForm?: sendForm;
  formSuccess: boolean = false;
  /** true ระหว่างกำลังส่งคำตอบ — กันกดส่งซ้ำ/ดับเบิลคลิก */
  submitting: boolean = false;
  /** ???????????????????????? (consent) ??????????? � ?????????????????????????????? */
  consentAccepted: boolean = false;
  formType: typeForm = {
    heading: 'heading',
    short: 'short',
    long: 'long',
    score: 'score',
    multiple: 'multiple',
    single: 'single',
    datepicker: 'datepicker',
    time: 'time',
    nps: 'nps',
    likert: 'likert',
    fileupload: 'fileupload',
    dropdown: 'dropdown',
  };
  view: boolean = false;
  viewPage: boolean = false;
  /** ??? URL ????????????? path ????????????????????????????? (theme_bg_image) */
  uploadsBaseURL: string = getUploadsBaseURL();
  constructor(private http: HttpClient,
    private _router: Router,
    private ac: ActivatedRoute,
    private alert: AlertService,
    private _auth: AuthService,
    private _abResolve: AbResolveService,
    private _formatDate: FormatDateService) {
    this.viewPage = true
    this.view = this.ac.snapshot.params['view']
    // console.log(this.view);
    setTimeout(() => {
      this.viewPage = false
    }, 500);

  }

  trackByIndex(index: number): number { return index; }

  /** map ???? theme_font (??? allow-list ???? backend) ????????????????? � null = ?????????????? (Inter) */
  private readonly fontFamilyMap: { [key: string]: string } = {
    sarabun: "'Sarabun', sans-serif",
    prompt: "'Prompt', sans-serif",
    kanit: "'Kanit', sans-serif",
    mitr: "'Mitr', sans-serif",
  };
  themeFontFamily(themeFont?: string | null): string | null {
    return themeFont ? (this.fontFamilyMap[themeFont] || null) : null;
  }

  /** ????????? (hex) ???? rgba ???????? ???????????????????????????????????? (??? MS Forms) � ??? null ????????? hex ?????????? */
  themeTint(hex?: string | null, alpha: number = 0.16): string | null {
    const m = hex ? /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.trim()) : null;
    if (!m) return null;
    const r = parseInt(m[1], 16), g = parseInt(m[2], 16), b = parseInt(m[3], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  /** แปลง path รูปภาพเป็น URL ที่โหลดได้จริง — ใช้ตัวช่วยกลาง resolveMediaUrl กันสูตรผิดเพี้ยนไปคนละแบบระหว่างจุดที่ต้องใช้ */
  resolveBgImageUrl(path?: string | null): string | null {
    return resolveMediaUrl(this.uploadsBaseURL, path);
  }
  resolveQuestionMediaUrl(path?: string | null): string | null {
    return resolveMediaUrl(this.uploadsBaseURL, path);
  }
  /** วันที่แสดงบนหน้าปก (เฉพาะเค้าโครง largebackground) แปลงเป็นรูปแบบไทยสั้น เช่น "8 ก.ค. 2569" */
  get coverDateLabel(): string {
    return this._formatDate.month(this.formView?.cover_date);
  }


  /** ???????????????????????????????? choice_randomize (Fisher-Yates) � ?????????????????? */
  private applyChoiceRandomize(form: any) {
    form?.pages?.forEach((pg: any) => {
      pg?.questions?.forEach((q: any) => {
        if (q?.choice_randomize && Array.isArray(q.choices) && q.choices.length > 1) {
          for (let i = q.choices.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [q.choices[i], q.choices[j]] = [q.choices[j], q.choices[i]];
          }
        }
      });
    });
  }

  /** ??????????????????????????????????????? randomize_questions (Fisher-Yates) � ?????????????????? */
  private applyQuestionRandomize(form: any) {
    if (!form?.randomize_questions) return;
    form?.pages?.forEach((pg: any) => {
      if (Array.isArray(pg?.questions) && pg.questions.length > 1) {
        for (let i = pg.questions.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [pg.questions[i], pg.questions[j]] = [pg.questions[j], pg.questions[i]];
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.ac.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      // A/B testing entry: ???????? /form?ab=<experiment_key> (??????????? key_id) ? ????/?? variant ??? sticky ???????????????????????????? publish_key
      if (params['ab'] && !params['key_id']) {
        this.resolveAbVariant(params['ab']);
        return;
      }
      if(params['form_id']) {
        this.form_id = params['form_id'];
      }
      if(params['key_id']) {
        this.key_id = params['key_id'];
      }
      if (params['tab'] === '1' || !params['tab']) {
        if (this.form_id && !this.userid) this.getForms();
        if (this.key_id) {
          this.modelForm = { key: '', answers: [] };
          this.modelForm.key = this.key_id;
          this.getFormsKey();
        }
      } 
    });
  }

  /**
   * A/B testing (sticky): ????? variant ?????? experiment_key ??????????????????? publish_key
   * ??????????: ???? localStorage ???????? � ????????????? variant ???? ?? "???" ????? resolve ???
   * ???????????????????????? variant ????????????????????? (?????????????????????????) ??????????????????? backend
   */
  private resolveAbVariant(experimentKey: string) {
    const storageKey = KeysConfig.abVariant + experimentKey;
    const stored = localStorage.getItem(storageKey);
    // replay: ?? publish_key ???????? ? ???????????????? ???????????? resolve
    if (stored) {
      this.loadByPublishKey(stored);
      return;
    }
    // ????????????? ? ??? backend ????? variant ?????? publish_key ?????????
    this._abResolve.resolve(experimentKey).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res?.publish_key) {
          localStorage.setItem(storageKey, res.publish_key);
          this.loadByPublishKey(res.publish_key);
        } else {
          // ????? variant ?????????? (??????/????????) ? ????????? "??????????????" ?????????????????
          this.showAbUnavailable(experimentKey);
        }
      },
      error: () => this.showAbUnavailable(experimentKey),
    });
  }

  /** ?????????????????????? publish_key ???????????????????? ?key_id=<publish_key> � ??????? query param ???? key_id ???????????? queryParams subscription ???????????????? */
  private loadByPublishKey(publishKey: string) {
    this._router.navigate([], {
      relativeTo: this.ac,
      queryParams: { key_id: publishKey },
      replaceUrl: true,
    });
  }

  /** ????? variant ???????????????? experiment ??? ? ???????? "????????????????????????" ???? (?????? key_id + formView ????????? ready ?????????????) */
  private showAbUnavailable(experimentKey: string) {
    this.key_id = experimentKey;
    this.formView = { expire: false };
  }

  formItem?: any = [];
  pageItem?: any = [];
  page: number = 0;
  actionPage: number = 0;
  // ?????? Admin
  getForms() {
    if (this.form_id)
      this.http.get(`/api/FormManage/${this.form_id}`).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          this.formItem = res.data;
          // ??????????? (??/?????/???????????) ????? /api/FormManage/{id} ??? � ???? "??????????" (form_id) ??????? publish link ??????????? formView.theme_* ?????????
          this.formView = {
            ...this.formView,
            theme_color: res.data?.theme_color ?? null,
            theme_bg_image: res.data?.theme_bg_image ?? null,
            theme_bg_position: res.data?.theme_bg_position ?? null,
            theme_font: res.data?.theme_font ?? null,
            cover_layout: res.data?.cover_layout ?? null,
            cover_date: res.data?.cover_date ?? null,
          };
          this.consentAccepted = false; // ????????????? ? ?????????? consent ????????
          this.applyChoiceRandomize(this.formItem);
          this.applyQuestionRandomize(this.formItem);
          this.page = this.formItem.pages.length;
          this.pageItem = this.formItem.pages[0];
          this.validCheck();
        },
        error: (err) => { console.error(err); },
      });
  }

  // ?????????????????
  private _formView: formViewIF = { expire: false };
  get formView(): formViewIF { return this._formView; }
  set formView(v: formViewIF) { this._formView = v; }
  needLogin: boolean = false;
  /** ?????????????????? (????????? allow_edit_response ???????????????????) */
  editMode: boolean = false;
  /** เวลาที่ผู้ตอบตอบคำถามข้อแรก — ตั้งครั้งเดียวใน updateValue/updateMatrix เพื่อคำนวณเวลาที่ใช้ทำแบบสอบถาม (ส่งไปกับ POST เท่านั้น ไม่ส่งตอนแก้ไข/PUT) */
  private firstAnswerAt: Date | null = null;
  /** ?????????????????? "???" ??????????? ? ????????? "?????????????????????????" ???????? */
  alreadyAnswered: boolean = false;
  /** ????????????????????????????? � ?????????????????? prefill ????? (children ?????????????????? render ????????) */
  editLoading: boolean = false;

  /** ??????????????????????????????????????? sign-in (?????????????????????????) */
  goLogin() {
    this._router.navigate(['', AppURL.account, AccountURL.login], {
      queryParams: { redirect: this._router.url },
    });
  }

  /** ??????? "??????????????? Google" (Google Identity Services) ???????????????????????????????????????
   *  ?????????? google ??????????????? ????????????????? (???????????????? async defer ?? index.html) */
  private renderGoogleSignInButton(retriesLeft: number = 20) {
    const google = (window as any).google;
    const target = document.getElementById('googleSignInBtn');
    if (!google?.accounts?.id || !target) {
      if (retriesLeft > 0) setTimeout(() => this.renderGoogleSignInButton(retriesLeft - 1), 250);
      return;
    }
    if (!environment.googleClientId) {
      console.warn('???????????????? environment.googleClientId � ???? "??????????????? Google" ?????????????????');
      return;
    }
    google.accounts.id.initialize({
      client_id: environment.googleClientId,
      callback: (response: any) => this.onGoogleCredential(response),
    });
    google.accounts.id.renderButton(target, { theme: 'outline', size: 'large', width: 280, text: 'signin_with' });
  }

  /** ?????????????????????????????? Google ??????: ??? ID token (credential) ??? backend ??? token ??????????
   *  ????????????????????? login ???? � token ??????? HttpConfig interceptor ????? saveToken ??????? (data.token_type === 'Bearer')
   *  ???????????????????????????????????????????????? */
  private onGoogleCredential(response: any) {
    const idToken = response?.credential;
    if (!idToken) return;
    const email = this.decodeGoogleEmail(idToken);
    this._auth.signInWithGoogle(idToken).pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        // token ???????????? interceptor ???? (?????? AccountService.postSignin) � ???????????????????????????????
        this.alert.notify('success', `??????????????? Google ??????${email ? ` (${email})` : ''}`);
        this.needLogin = false;
        this.getFormsKey();
      },
      error: (err: any) => {
        this.alert.notify('error', err?.message || '??????????????? Google ????????? ????????????????????');
      },
    });
  }

  /** ??????????? Google ID token (JWT) ??????? client ?????????????????????????? � ??????????????????????? (???? verify ??????? backend) */
  private decodeGoogleEmail(idToken: string): string {
    try {
      const payload = idToken.split('.')[1];
      const json = decodeURIComponent(
        atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(json)?.email || '';
    } catch {
      return '';
    }
  }

  getFormsKey() {
    if (this.key_id)
      this.http.get(`/api/Publish/bykey/${this.key_id}`).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          this.formView = res?.data;
          // ?????????????????????????????
          this.editMode = false;
          this.alreadyAnswered = false;
          this.editLoading = false;
          const allowEdit = !!this.formView?.allow_edit_response;
          const hasAnswered = !!this.formView?.has_answered;
          // ????????????????????: ??? require_login ???????????????? ? ?????????????????? (????????????????)
          if (this.formView?.require_login && !this._auth.isLoggedIn) {
            this.needLogin = true;
            setTimeout(() => this.renderGoogleSignInButton());
            return;
          }
          if (!this.formView.form) return;
          this.formItem = res?.data?.form;
          this.consentAccepted = false; // ????????????? ? ?????????? consent ????????
          this.applyChoiceRandomize(this.formItem);
          this.applyQuestionRandomize(this.formItem);
          this.page = this.formItem?.pages?.length;
          this.pageItem = this.formItem?.pages[0];
          this.pageItem.questions.forEach((f: any) => {
            if (f.question_required) f.valid = true;
          });
          this.validCheck();
          // ?????????????????????????????????
          if (hasAnswered) {
            if (allowEdit) {
              // ?????????????: ???????????????? ??????????????????? prefill
              this.editMode = true;
              this.editLoading = true;
              this.loadMyAnswers();
            } else {
              // ?????????????? ? ????????? "?????????????????????????"
              this.alreadyAnswered = true;
            }
          }
        },
        error: (err) => { console.error(err); },
      });
  }

  /**
   * ???????????????????????????????? (?????????) ????????????????????????????
   * ???????????????????????????????? (editLoading=false) ????? children ?????????????????? render ????????????????
   */
  private loadMyAnswers() {
    this.http.get(`/api/ResponseAnswer/mine/${this.key_id}`).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        const answers = res?.data;
        if (Array.isArray(answers) && answers.length > 0 && this.modelForm) {
          this.modelForm.answers = answers as valueForm[];
          // ???????????????????? (?????????????????) ???????????????????????????????? flag ????????????????????
          (this.formItem?.pages || []).forEach((pg: any) => this.insertValue(pg, 'N'));
          this.actionPage = 0;
          this.pageItem = this.formItem?.pages[0];
          this.validCheck();
        }
        this.editLoading = false;
      },
      error: (err) => { console.error(err); this.editLoading = false; },
    });
  }

  userid: any;
  @Input('model') set item(v: any) {
    this.userid = v;
    if (this.userid) this.getUserKey(v);
  }

  getUserKey(userid: any) {
    if (userid)
      this.http
        .get(`/api/FormSummary/individual/byid/${userid[0].response_id}`)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            this.formItem = res.data;
            this.consentAccepted = false; // ????????????? ? ?????????? consent ????????
            this.page = this.formItem.pages.length;
            this.pageItem = { questions: [] };
            let items: any[] = [];
            this.formItem.pages.forEach((f: any) => {
              f.questions.forEach((q: any) => {
                this.pageItem.questions.push(q);
                q.view = true;
              });
            });
          },
          error: (err) => { console.error(err); },
        });
  }

  backPage() {
    // ??????????????????? (backURL ?????) ??????????? Home � ??????????? Menu
    const backURL = this.ac.snapshot.queryParams['backURL'];
    if (backURL) {
      this._router.navigate(JSON.parse(backURL), { queryParams: { form_id: this.form_id } });
    } else {
      this._router.navigate(['', AppURL.home]);
    }
  }

  updateValue(form: any, value: any) {
    if (this.form_id) return;
    if (value.length == 0) {
      form.valid = true;
      this.validCheck();
      return;
    } else {
      if (!this.firstAnswerAt) this.firstAnswerAt = new Date();
      form.valid = false;
      let formValue: string = '';
      let formValueArray: choice_array[] = [];
      if (typeof value == 'string') formValue = value;
      if (typeof value == 'object') {
        if (form?.choices_value) {
          form.valid = false;
        }

        value.forEach((f: any) => {
          // ?????????? id ???? (string) ??? object {question_choice_id, choice_value} ?????????????? "???? ? (????)"
          if (f && typeof f === 'object') {
            formValueArray.push({ question_choice_id: f.question_choice_id, choice_value: f.choice_value ?? null });
          } else {
            formValueArray.push({ question_choice_id: f });
          }
        });
      }
      let model: valueForm = {
        question_id: form.question_id,
        answer_value: formValue,
        choices: formValueArray,
      };

      if (this.modelForm?.answers.length == 0)
        this.modelForm?.answers.push(model);
      if (
        !this.modelForm?.answers.find(
          (fn: valueForm) => fn.question_id == form.question_id
        )
      )
        this.modelForm?.answers.push(model);
      else {
        let find = this.modelForm?.answers.find(
          (fn: valueForm) => fn.question_id == form.question_id
        );
        if (find) {
          find.answer_value = formValue;
          find.choices = formValueArray;
        }
      }
      this.validCheck();
    }
  }

  /**
   * ??????????????????? Matrix/Grid � choices ??????? (question_choice_id + matrix_row_id) ??????
   * ???????? modelForm.answers ???? 1 answer ???????? (answer_value ????, ??? choices ??????????)
   */
  updateMatrix(form: any, choices: choice_array[]) {
    if (this.form_id) return; // ???? preview ??????????????
    if (!this.firstAnswerAt) this.firstAnswerAt = new Date();
    const list: choice_array[] = choices || [];
    const existing = this.modelForm?.answers.find(
      (a: valueForm) => a.question_id == form.question_id
    );
    if (existing) {
      existing.answer_value = '';
      existing.choices = list;
    } else {
      this.modelForm?.answers.push({
        question_id: form.question_id,
        answer_value: '',
        choices: list,
      });
    }
    form.choices_value = list; // sync ????????? insertValue ???????????
    this.validCheck();
  }

  next() {
    if (this.valid) return;
    if (this.validate) return;
    const branch = this.resolveBranchTarget();
    let target = branch !== null ? branch : this.actionPage + 1;
    if (target === -1) target = this.formItem.pages.length - 1;
    const lastVisible = this.lastVisiblePageIndex;
    target = Math.max(0, Math.min(target, lastVisible));
    // ไม่มีการตั้งเงื่อนไขแสดง/ซ่อนระดับหน้าโดยตรง — อาศัยเงื่อนไข "แสดงข้อนี้เมื่อ" ของแต่ละคำถามแทน
    // ถ้าทุกคำถามในหน้าปลายทางถูกซ่อนหมด (ไม่ตรงเงื่อนไข) ให้ข้ามหน้านั้นไปเรื่อย ๆ กันหน้าที่ว่างเปล่าโผล่ขึ้นมา
    while (target < lastVisible && this.pageIsSkippable(this.formItem.pages[target])) {
      target++;
    }
    this.actionPage = target;
    this.pageItem = this.formItem.pages[this.actionPage];
    this.insertValue(this.pageItem, 'N');
  }

  /** หน้าที่มีคำถามอยู่แต่ทุกข้อ "ถูกยืนยันแล้วว่าซ่อนแน่นอน" — ควรข้ามหน้านี้ไปเลย (หน้าที่ไม่มีคำถาม เช่นหน้าข้อมูลอย่างเดียว ไม่ถือว่าข้ามได้) */
  private pageIsSkippable(page: any): boolean {
    const questions = page?.questions || [];
    if (!questions.length) return false;
    return questions.every((q: any) => this.isQuestionDefinitivelyHidden(q));
  }

  /**
   * "ซ่อนแน่นอน" ต่างจาก isQuestionVisible()===false ตรงที่ isQuestionVisible ใช้กับการ "แสดงผลตอนนี้" (ยังไม่ตอบ = ซ่อนไว้ก่อนอย่างระมัดระวัง)
   * แต่ฟังก์ชันนี้ใช้ตัดสินใจ "ข้ามทั้งหน้า/หาหน้าสุดท้าย" — ต้องแยกให้ออกว่าซ่อนเพราะ "ตอบแล้วไม่ตรงเงื่อนไข" (ข้ามได้จริง)
   * กับซ่อนเพราะ "คำถามต้นทางยังไม่ถูกตอบเลย" (ยังสรุปไม่ได้ว่าจะซ่อนถาวรหรือไม่ ต้องไม่ข้าม กันข้ามทั้งฟอร์มไปจบตั้งแต่หน้าแรกก่อนตอบอะไรเลย)
   * ไล่แบบ recursive เพราะเงื่อนไขอาจต่อกันเป็นทอด ๆ (เช่น ข้อ3/4 ขึ้นกับข้อ2 ซึ่งขึ้นกับข้อ1 อีกที) — ถ้าต้นทางไกลสุดถูกยืนยันว่าซ่อนแน่นอนแล้ว ข้อที่ต่อเนื่องมาก็ซ่อนแน่นอนไปด้วย
   */
  private isQuestionDefinitivelyHidden(q: any): boolean {
    if (!q?.condition_question_id || !q?.condition_choice_id) return false;
    const ctrl = this.modelForm?.answers?.find((a: any) => a.question_id === q.condition_question_id);
    if (ctrl) {
      if (!ctrl.choices?.length) return true;
      return !ctrl.choices.some((c: any) => c.question_choice_id === q.condition_choice_id);
    }
    // คำถามต้นทางยังไม่ถูกตอบ — ซ่อนแน่นอนได้ก็ต่อเมื่อตัวต้นทางเองก็ถูกยืนยันว่าซ่อนแน่นอนอยู่แล้ว (ไล่ทอดต่อไปเรื่อย ๆ)
    const gatingQuestion = this.findQuestionById(q.condition_question_id);
    return gatingQuestion ? this.isQuestionDefinitivelyHidden(gatingQuestion) : false;
  }

  /**
   * หน้าสุดท้ายที่ผู้ตอบคนนี้จะได้เห็นจริง (ไล่จากหน้าท้ายสุดของฟอร์มย้อนขึ้นมาหาหน้าแรกที่ไม่ถูกซ่อนทั้งหน้า)
   * ใช้แทนการอิงว่า "หน้าสุดท้ายในลิสต์คือหน้าจบ" เสมอ เพราะฟอร์มที่แตกกิ่ง (branch) หลายทาง แต่ละทางอาจจบไม่เท่ากัน
   * (เช่นทางที่ตอบ "ไม่เคยใช้บริการ" หน้าสุดท้ายในลิสต์คือหน้าของตัวเอง แต่ทางที่ "เคยใช้บริการ" หน้านั้นถูกซ่อน ต้องจบที่หน้าก่อนหน้าแทน)
   */
  get lastVisiblePageIndex(): number {
    const pages = this.formItem?.pages || [];
    for (let i = pages.length - 1; i >= 0; i--) {
      if (!this.pageIsSkippable(pages[i])) return i;
    }
    return pages.length - 1;
  }

  /**
   * ?? conditional branching (?????????? FE � client-only, ???????? BE ??????):
   * ??????? single/multiple ??????????????? ?????????????????????? modelForm.answers
   * ???????????? choice ????? branch_target_page ?????????? � ??????????????? ???? null ????????
   */
  private resolveBranchTarget(): number | null {
    for (const q of this.pageItem?.questions || []) {
      if (q.question_type_id !== 'single' && q.question_type_id !== 'multiple' && q.question_type_id !== 'dropdown') continue;
      const answer = this.modelForm?.answers.find((a: valueForm) => a.question_id === q.question_id);
      if (!answer?.choices?.length) continue;
      for (const selected of answer.choices) {
        const choice = (q.choices || []).find((c: any) => c.question_choice_id === selected.question_choice_id);
        if (!choice) continue;
        // ???????????????? ? -1 (next() ???????????????????)
        if (choice.branch_target_end) return -1;
        // ????????????????? form_page_id ? ?? index ???????? (????????????????????????)
        if (choice.branch_target_page_id) {
          const idx = (this.formItem?.pages || []).findIndex((p: any) => p.form_page_id === choice.branch_target_page_id);
          if (idx >= 0) return idx;
        }
      }
    }
    return null;
  }

  back() {
    let target = this.actionPage - 1;
    // ข้ามย้อนกลับผ่านหน้าที่ถูกซ่อนทั้งหน้าเช่นเดียวกับ next() กันกดย้อนกลับแล้วไปเจอหน้าว่างเปล่า
    while (target > 0 && this.pageIsSkippable(this.formItem.pages[target])) {
      target--;
    }
    this.actionPage = Math.max(0, target);
    this.pageItem = this.formItem.pages[this.actionPage];
    this.insertValue(this.pageItem, 'B');
  }

  insertValue(pageItem: any, str: string) {
    pageItem.questions.forEach((f: setForm) => {
      let find = this.modelForm?.answers.find(
        (fn: valueForm) => fn.question_id == f.question_id
      );
      if (find) {
        f.answer_value = find?.answer_value;
        f.choices_value = find?.choices;
      }
      if (f.question_required) {
        if (f.choices_value?.length > 0) {
          f.valid = false;
          return;
        }
        if (f.answer_value) {
          f.valid = false;
          return;
        } else f.valid = true;
      }
    });
    this.validCheck();
  }

  sendForm() {
    if (this.submitting) return; // กันกดส่งซ้ำ/ดับเบิลคลิกระหว่างรอ response
    this.pruneHiddenAnswers();
    let request$;
    if (this.editMode) {
      request$ = this.http.put(`/api/ResponseAnswer`, this.modelForm);
    } else {
      if (this.modelForm) {
        this.modelForm.consent_accepted = !!this.formItem?.require_consent && this.consentAccepted;
        this.modelForm.started_at = this.firstAnswerAt ? this.firstAnswerAt.toISOString() : undefined;
      }
      request$ = this.http.post(`/api/ResponseAnswer`, this.modelForm);
    }
    this.submitting = true;
    this.alert.loadingPage(true);
    request$.pipe(takeUntil(this.destroy$), finalize(() => { this.submitting = false; this.alert.loadingPage(false); })).subscribe({
      next: (res: any) => {
        const data = (res?.data ?? res) as QuizResultIF;
        this.quizResult = data?.is_quiz ? data : undefined;
        this.formSuccess = true;
        if (this.editMode) this.alert.notify('success', 'บันทึกการแก้ไขคำตอบสำเร็จ');
      },
      error: (err) => {
        console.error(err);
        // โชว์ข้อความ error จาก backend ให้ผู้ตอบเห็น (ครอบคลุมทั้ง 400 เดิม และ 503 โหมด async ที่ลองส่งซ้ำได้)
        // ไม่ล้าง modelForm/ไม่ตั้ง formSuccess — คงคำตอบไว้ให้ผู้ตอบกดส่งซ้ำได้ทันที
        this.alert.notify('warning', err?.message || 'ขออภัย ไม่สามารถส่งคำตอบได้ กรุณาลองใหม่อีกครั้ง');
      },
    });
  }

  /** ?????????????????????? � undefined ??????????? quiz (???????????????????????????) */
  quizResult?: QuizResultIF;

  /** ??????????????????? (??????) � 0 ??????????????????? */
  get quizPercent(): number {
    const max = this.quizResult?.max_score;
    const score = this.quizResult?.score;
    if (!max || max <= 0 || score == null) return 0;
    return Math.round((score / max) * 100);
  }

  /** ???????????????????? question_id ????????????? (public wrapper ?????? template) */
  quizQuestionDef(qid: string): any {
    return this.findQuestionById(qid);
  }

  /** ???????????????????? � ??? question_name ??? form definition (fallback ???????????) */
  quizQuestionName(qid: string): string {
    return this.quizQuestionDef(qid)?.question_name || '';
  }

  /**
   * ????????? question_choice_id ????????????????????????????? (choice_name) ??? map ??? form definition
   * id ??? map ?????????????????? � ??? [] ?????????? id
   */
  quizChoiceLabels(qid: string, choiceIds: string[]): string[] {
    if (!choiceIds?.length) return [];
    const choices: any[] = this.quizQuestionDef(qid)?.choices || [];
    return choiceIds
      .map((id) => choices.find((c: any) => c.question_choice_id === id)?.choice_name)
      .filter((name: any): name is string => !!name)
      // choice_name เป็น HTML — ตัด tag ก่อนเพราะจะเอาไป join(', ') แล้วแสดงเป็นข้อความล้วนในสรุปผลควิซ ไม่ใช่จุดที่ต้องคงสไตล์
      .map((name: string) => this.stripHtml(name));
  }

  /** ?????????????????? (consent) ???????????????? ??????????????????????? � ???????? "???????" ?????????????????????? */
  get showConsentGate(): boolean {
    return !this.view && !this.formSuccess && !this.needLogin
      && !!this.formItem?.require_consent && !this.consentAccepted
      && !!(this.userid || this.key_id || this.form_id);
  }

  acceptConsent() { this.consentAccepted = true; }

  replay() {
    this.consentAccepted = false;
    window.location.reload();
  }

  /** ??????????????????????? (????????????) ??????????? � ????????????????????? "??????" */
  copyShareLink() {
    navigator.clipboard.writeText(window.location.href).then(() => {
      this.alert.notify('success', '????????????????????????');
    }).catch(() => {
      this.alert.notify('warning', '????????????????????');
    });
  }

  shareLine() {
    window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(window.location.href)}`, '_blank');
  }

  shareFacebook() {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`, '_blank');
  }

  validate: boolean = false;
  updateValiDate(form: any, e: any) {
    let find = this.pageItem?.questions.find(
      (fn: any) => fn.question_id == form.question_id
    );
    find.valid = e;
    // ????????????????? ???????????? "?????/???" ??????????????????????????????? (???? ?????/??????)
    this.validCheck();
  }

  valid: boolean = false;
  validCheck() {
    if (this.form_id) {
      this.valid = false;
      return;
    }
    let required = this.pageItem?.questions.filter(
      (fl: any) => fl.valid == true && this.isQuestionVisible(fl)
    );
    if (required.length > 0) this.valid = true;
    else this.valid = false;
  }

  alertMessage() {
    this.alert.dialog('?????????????????');
  }

  /** ???????????????????? question_id ????????????? � ?????????????????????????????? (userid) ???????? modelForm.answers */
  private findQuestionById(qid: string): any {
    for (const pg of this.formItem?.pages || []) {
      const found = (pg?.questions || []).find((qq: any) => qq.question_id === qid);
      if (found) return found;
    }
    return null;
  }

  /** ?????????????????????? ??????????? show/hide (???????????????????????) */
  isQuestionVisible(q: any): boolean {
    if (!q?.condition_question_id || !q?.condition_choice_id) return true;
    // ???????????/???????: ??????????????????? modelForm.answers (??????????????? resolveBranchTarget)
    const ctrl = this.modelForm?.answers?.find(
      (a: any) => a.question_id === q.condition_question_id
    );
    if (ctrl) {
      if (!ctrl.choices?.length) return false;
      return ctrl.choices.some((c: any) => c.question_choice_id === q.condition_choice_id);
    }
    // ?????????????????/??????: ????? modelForm.answers ? ??????????????????????????????? (choices_value)
    const ctrlQ = this.findQuestionById(q.condition_question_id);
    const captured: any[] = ctrlQ?.choices_value || [];
    if (!captured.length) return false;
    return captured.some((c: any) => c.question_choice_id === q.condition_choice_id);
  }

  /** ???????????????????????????????????? ?????? modelForm.answers ??????? (????????????????????????????????) */
  private pruneHiddenAnswers() {
    if (!this.modelForm?.answers) return;
    const visibleIds = new Set<string>();
    (this.formItem?.pages || []).forEach((pg: any) =>
      (pg?.questions || []).forEach((q: any) => {
        if (this.isQuestionVisible(q)) visibleIds.add(q.question_id);
      })
    );
    this.modelForm.answers = this.modelForm.answers.filter((a: any) =>
      visibleIds.has(a.question_id)
    );
  }
}
